import styled from "styled-components";

export const BillingShippingContainer = styled.div`
  width: 95%;
  height: 315px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 25px;
  display: flex;
  left: 0px;
  justify-content: space-around;
  align-items: center;
`;
export const BillingShippingContentContainer = styled.div`
  width: 100%;
  min-height: 380px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const BillingShippingContentContainerContent = styled.div`
  width: 100%;
  height: 180px;
  margin-top: 15px;
  display: flex;
  align-items: center;
`;
export const BillingShippingContentContainerContentShipping = styled.div`
  min-width: 730px;
  height: 65px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  border: 0.3px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  label {
    width: 170px;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      font-size: 19px;
      font-family: "Akrobat ExtraBold";
      color: #ff7e00;
      letter-spacing: 0.03rem;
    }
  }

  select {
    min-width: 415px;
    height: 30px;
    border: none;
    border-radius: 3px;
    outline: none;

    font-size: 19px;
    font-family: "Akrobat SemiBold";
    color: rgb(61,61,61);
  }

  p {
    font-size: 22px;
    font-family: "Akrobat";
    color: rgb(61,61,61);
    margin-right: 10px;
  }
`;
export const BillingShippingContentContainerContentShippingResume = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
`;
export const BillingShippingContentContainerContentShippingResumeContent = styled.div`
  width: 80%;
  height: 50%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  p {
    font-size: 20px;
    font-family: "Akrobat";
    color: rgb(61,61,61);

    strong {
      font-family: "Akrobat ExtraBold";
    }
  }
`;
